export const ASK_PATH = "/ask";
/** One conversation, shared by the ask bar and the /ask page. */
export const ASK_STORAGE_KEY = "ast-ask";
const PENDING_KEY = "ast-ask-pending";

/** Leaves a question for /ask to send once it has the conversation back. */
export function handOff(question: string) {
  try {
    sessionStorage.setItem(PENDING_KEY, question);
  } catch {}
}

/** The question the ask bar left, read once: leaving /ask mid-answer must not ask it again on the next visit. */
export function takeHandOff(): string | null {
  try {
    const q = sessionStorage.getItem(PENDING_KEY);
    sessionStorage.removeItem(PENDING_KEY);
    return q;
  } catch {
    return null;
  }
}
